import { atom } from 'jotai';
import { Group } from './types';

// Selected group for creating posts
export const selectedGroupAtom = atom<Group | null>(null);

// Auth bottom sheet visibility
export const authSheetVisibleAtom = atom<boolean>(false);

// Create zone bottom sheet visibility
export const createZoneSheetVisibleAtom = atom<boolean>(false);

// Create post bottom sheet visibility
export const createPostSheetVisibleAtom = atom<boolean>(false);

// Current header subtitle (zone name for post detail)
export const headerSubtitleAtom = atom<string | null>(null);

// Username setup modal visibility
export const usernameSetupModalVisibleAtom = atom<boolean>(false);
